import type { BeautifierSettings, ImagePreset, PostContent } from "@/lib/types";

export const imagePresets: ImagePreset[] = [
  { id: "square", label: "Square 1080x1080", width: 1080, height: 1080 },
  { id: "linkedin", label: "LinkedIn 1200x627", width: 1200, height: 627 },
  { id: "portrait", label: "Instagram portrait 1080x1350", width: 1080, height: 1350 },
  { id: "story", label: "Story 1080x1920", width: 1080, height: 1920 },
  { id: "presentation", label: "Presentation 16:9", width: 1280, height: 720 },
];

export const gradientPresets = [
  {
    id: "aurora",
    label: "Aurora",
    value: "linear-gradient(135deg, #146C94 0%, #00A896 48%, #F2A541 100%)",
  },
  {
    id: "paper",
    label: "Paper",
    value: "linear-gradient(135deg, #F5F0E8 0%, #FFFFFF 52%, #DDE7F0 100%)",
  },
  {
    id: "berry",
    label: "Berry",
    value: "linear-gradient(135deg, #243B55 0%, #5F2C82 48%, #F2994A 100%)",
  },
  {
    id: "fresh",
    label: "Fresh",
    value: "linear-gradient(135deg, #EEF2F3 0%, #8EC5B6 48%, #2E6F95 100%)",
  },
];

export const samplePost: PostContent = {
  url: "",
  authorName: "Maya Chen",
  authorHeadline: "Founder at BrightOps | Building calmer content systems",
  profileImage: "",
  profileHeaderImage: "",
  postImage: "",
  timestamp: "2h",
  text: "A useful content system is less about posting more and more about making each idea easier to reuse.\n\nThis week we turned one customer story into a LinkedIn post, a slide, a newsletter snippet, and a sales enablement note. Same insight, different rooms.\n\nThat is the leverage most teams are missing.",
};

export const defaultPost: PostContent = {
  url: "",
  authorName: "Alex Morgan",
  authorHeadline: "Product strategist | B2B storytelling",
  profileImage: "",
  profileHeaderImage: "",
  postImage: "",
  timestamp: "Today",
  text: "",
};

export const defaultSettings: BeautifierSettings = {
  backgroundType: "gradient",
  backgroundColor: "#F6F8FB",
  gradientPreset: "aurora",
  patternType: "dots",
  customBackgroundImage: "",
  cardBackgroundColor: "#FFFFFF",
  textColor: "#17202A",
  cardOpacity: 96,
  padding: 72,
  borderRadius: 32,
  shadowIntensity: 42,
  postImageFit: "fit",
  postImageHeight: 46,
  imagePresetId: "square",
  exportFormat: "png",
  jpgQuality: 92,
};

export const storageKey = "beautifyin-state-v1";
